import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Stack,
  useMediaQuery,
  useTheme,
  Container,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EastIcon from "@mui/icons-material/East";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../../context/LanguageContext";
const features = ["Instant Setup", "24/7 Support", "Deep Liquidity"];

const NewCommonity = ({ title, subtitle }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { language, translations } = useLanguage();

  useEffect(() => {
    AOS.init({
      duration: 1000, // default animation duration
      once: false, // whether animation should happen only once
    });
  }, []);

  return (
    <Box sx={{ padding: { xs: " 10px" } }}>
      <Box
        sx={{
          // background: "linear-gradient(to right, #1E90FF, #00BFFF)",
          paddingTop: 0.1,
          borderRadius: "20px",
          minHeight: "420px",
        }}
      >
        <Box
          sx={{
            backgroundImage: "url('https://res.cloudinary.com/dk24unkwu/image/upload/v1753695253/wealthback_q2mozc.png')", // ← replace with your image path
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            py: { xs: 2, md: 4 },
            textAlign: "center",
            px: 2,
            borderRadius: "20px",
            color: "#000",
            minHeight: "450px",
            marginBottom: "30px",
            border: "0.2px solid rgba(36, 148, 201, 0.5)",
          }}
        >
          {/* Logo */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: 2,
                // boxShadow: 3,
                overflow: "hidden",
              }}
            >
              <img
                src="/Images/ShadowLogo.png"
                alt="Logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
          </Box>

          {/* Heading */}
          <Box>
            <Typography
              variant={isMobile ? "h5" : "h2"}
              fontWeight={700}
              sx={{
                mb: 3,
                lineHeight: "70px",
                fontSize: { xs: "23px", sm: "45px", md: "55px", lg: "60px" },
              }}
            >
              {title}
            </Typography>
          </Box>

          {/* Features */}
          <Box>
            <Typography
              variant="caption"
              color="rgba(0, 0, 0, 0.7)"
              mt={3}
              display="block"
              textAlign="center"
              style={{ fontSize: "15px", fontWeight: "500" }}
            >
              {subtitle}
            </Typography>
          </Box>

          {/* CTA Button */}
          <Button
            disableRipple
            variant="contained"
            component="a"
            href="https://portal.bbcorp.trade/auth/jwt/sign-up/" // ← your actual link here
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: "rgba(25, 171, 226, 1)",
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 400,
              px: 4,
              py: 1.5,
              boxShadow: "none",
              marginTop: "22px",
              color: "rgba(255, 255, 255, 1)",
              "&:hover": {
                backgroundColor: "rgba(25, 171, 226, 1)",
                color: "#fff",
                boxShadow: "none",
              },
              "&:active": {
                boxShadow: "none", // 🛑 no shadow on click
              },
            }}
          >
            {translations[language]?.blueBTN}&nbsp;
            <EastIcon />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NewCommonity;
